module.exports = __webpack_public_path__ + "img/inco2.bfd893bb.png";